import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../lib/api'
import { Button, Field, Input } from '../components/ui'

export function LoginPage({ onDone }: { onDone: () => void }) {
  const navigate = useNavigate()
  const [phone, setPhone] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await api.post('/api/auth/login', { phone, password })
      onDone()
      navigate('/', { replace: true })
    } catch (err) {
      setError((err as Error).message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="flex min-h-dvh items-center justify-center bg-bg px-5">
      <form onSubmit={submit} className="w-full max-w-95">
        <h1 className="mb-1 text-center text-[28px] font-bold">
          牙记 <span className="text-brand-600">GigiBook</span>
        </h1>
        <p className="mb-8 text-center text-[17px] text-ink-2">请先登录</p>

        <div className="flex flex-col gap-5 rounded-lg border border-line bg-white p-6 shadow-sm">
          {error && (
            <div className="rounded-md border border-bad-line bg-bad-bg px-4 py-3 text-[16px] text-bad">
              {error}
            </div>
          )}

          <Field label="手机号">
            <Input
              autoFocus
              inputMode="tel"
              autoComplete="username"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="0123456789"
            />
          </Field>

          <Field label="密码">
            <Input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Field>

          <Button
            type="submit"
            block
            size="lg"
            variant="primary"
            loading={busy}
            disabled={!phone || !password}
          >
            登录
          </Button>
        </div>
      </form>
    </div>
  )
}
